import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: {
    textTransform: "none",
    width: 240,
    flexGrow: 1,
    backgroundColor: "#344955",
    "&:hover": {
      backgroundColor: "#344955"
    },
    color: "#fff"
    // color: "#f9aa33"
  }
}));

export default function CommonButton(props) {
  const classes = useStyles();

  return (
    <div>
      <Button className={classes.root} onClick={props.click}>
        {props.text}
      </Button>
    </div>
  );
}
